import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { formatMobile } from "../../../global-client";

const CustomerSection = ({ customerData, onUpdate }) => {
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const labelBgColor = useColorModeValue("gray.100", "gray.700");

  const [customer, setCustomer] = useState({
    CUSTOMER_ID: 0,
    CUST_FNAME: "",
    CUST_SNAME: "",
    CUST_CONT1: "",
    CUST_CONT2: "",
    CUST_EMAIL: "",
    CUST_POSTCODE: "",
    CONT_FNAME1: "",
    CONT_SNAME1: "",
  });

  const [jobCount] = useState(0);

  useEffect(() => {
    if (customerData) {
      setCustomer(customerData);
    }
  }, [customerData]);

  const handleChange = (field, value) => {
    const updated = { ...customer, [field]: value };
    setCustomer(updated);
    onUpdate(updated);
  };

  const handlePhoneChange = (field, value) => {
    // Remove non-digits
    const digitsOnly = value.replace(/\D/g, "");
    if (digitsOnly.length <= 10) {
      handleChange(field, digitsOnly);
    }
  };

  const smartCase = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <Box bg={bgColor} p={3} borderRadius='md' border='1px' borderColor={borderColor} height='100%'>
      <Heading size='sm' bg={labelBgColor} p={2} borderRadius='md' mb={3}>
        Customer Details
      </Heading>

      <VStack spacing={2} alignItems='stretch'>
        <HStack>
          <FormControl>
            <FormLabel fontSize='xs'>First Name</FormLabel>
            <Input
              size='sm'
              value={customer.CUST_FNAME || ""}
              onChange={(e) => handleChange("CUST_FNAME", e.target.value)}
              onBlur={(e) => handleChange("CUST_FNAME", smartCase(e.target.value))}
              placeholder='First Name'
            />
          </FormControl>
          <FormControl>
            <FormLabel fontSize='xs'>Surname</FormLabel>
            <Input
              size='sm'
              value={customer.CUST_SNAME || ""}
              onChange={(e) => handleChange("CUST_SNAME", e.target.value)}
              onBlur={(e) => handleChange("CUST_SNAME", smartCase(e.target.value))}
              placeholder='Surname'
            />
          </FormControl>
        </HStack>

        <HStack>
          <FormControl>
            <FormLabel fontSize='xs'>Phone 1</FormLabel>
            <Input
              size='sm'
              value={formatMobile(customer.CUST_CONT1 || "")}
              onChange={(e) => handlePhoneChange("CUST_CONT1", e.target.value)}
              placeholder='04XX XXX XXX'
            />
          </FormControl>
          <FormControl>
            <FormLabel fontSize='xs'>Phone 2</FormLabel>
            <Input
              size='sm'
              value={formatMobile(customer.CUST_CONT2 || "")}
              onChange={(e) => handlePhoneChange("CUST_CONT2", e.target.value)}
              placeholder='04XX XXX XXX'
            />
          </FormControl>
        </HStack>

        <FormControl>
          <FormLabel fontSize='xs'>Email</FormLabel>
          <Input
            size='sm'
            type='email'
            value={customer.CUST_EMAIL || ""}
            onChange={(e) => handleChange("CUST_EMAIL", e.target.value.toLowerCase())}
            placeholder='customer@email.com'
          />
        </FormControl>

        <FormControl>
          <FormLabel fontSize='xs'>Postcode</FormLabel>
          <Input
            size='sm'
            value={customer.CUST_POSTCODE || ""}
            onChange={(e) => handleChange("CUST_POSTCODE", e.target.value.toUpperCase())}
            placeholder='Postcode'
            maxLength={4}
          />
        </FormControl>

        <Box borderTop='1px' borderColor={borderColor} pt={3}>
          <FormLabel fontSize='xs' mb={2}>
            Preferred Contact 2 (Optional)
          </FormLabel>
          <HStack>
            <FormControl>
              <Input
                value={customer.CONT_FNAME1 || ""}
                onChange={(e) => handleChange("CONT_FNAME1", e.target.value)}
                onBlur={(e) => handleChange("CONT_FNAME1", smartCase(e.target.value))}
                placeholder='First Name'
                size='sm'
              />
            </FormControl>
            <FormControl>
              <Input
                value={customer.CONT_SNAME1 || ""}
                onChange={(e) => handleChange("CONT_SNAME1", e.target.value)}
                onBlur={(e) => handleChange("CONT_SNAME1", smartCase(e.target.value))}
                placeholder='Surname'
                size='sm'
              />
            </FormControl>
          </HStack>
        </Box>

        {customer.CUSTOMER_ID > 0 && (
          <HStack justifyContent='space-between' pt={2}>
            <Text fontSize='sm' color='gray.500'>
              Previous Jobs: {jobCount}
            </Text>
            <Button size='sm' colorScheme='blue' variant='outline'>
              View Customer
            </Button>
          </HStack>
        )}
      </VStack>
    </Box>
  );
};

export default CustomerSection;
